// Русский (User Panel)
const ru = {
  common: {
    loading: "Загрузка...",
    back: "Назад",
    cancel: "Отмена",
    confirm: "Подтвердить",
    save: "Сохранить",
    saved: "Сохранено",
    submit: "Отправить",
    submitting: "Отправка...",
    saving: "Сохранение...",
    ok: "ОК",
    error: "Ошибка",
    success: "Успешно",
    pending: "Ожидает",
    approved: "Одобрено",
    rejected: "Отклонено",
    completed: "Завершено",
    all: "Все",
    failed: "Неудачно",
    select_language: "Выберите язык",
    language: "Язык",
    unable_server: "Не удалось связаться с сервером. Пожалуйста, попробуйте снова.",
    fill_all: "Пожалуйста, заполните все поля",
    hint_disabled: "Депозиты и выводы временно отключены",
    account_disabled:
      "Операции отключены для вашего аккаунта. Пожалуйста, обратитесь в службу поддержки.",
  },

  navbar: {
    home: "Главная",
    history: "История",
    starting: "Старт",
    services: "Сервисы",
    my_profile: "Мой профиль",
  },

  page: {
    home: "Главная",
    history: "История",
    services: "Сервисы",
    deposit: "Депозит",
    withdraw: "Вывод",
    widthraw_page: "Вывод",
    withdrawal_account: "Счёт для вывода",
    deposit_history: "История депозитов",
    withdraw_history: "История выводов",
    starting: "Старт",
    my_profile: "Мой профиль",
    security_pin: "PIN-код",
    login_password: "Пароль для входа",
    invite_friends: "Пригласить друзей",
    about_us: "О нас",
    faq: "FAQ",
    vip_rules: "Правила VIP",
    invitation_rules: "Правила приглашений",
    about_us_details: "О нас",
  },

  home: {
    welcome: "Добро пожаловать",
    vip_level: "Уровни VIP",
    popular: "Популярное",
    deposit: "Депозит",
    withdrawal: "Вывод",
    about_us: "О нас",
    invite_friends: "Пригласить друзей",
  },

  deposit: {
    title: "Депозит",
    amount_label: "Сумма депозита",
    total_balance: "Общий баланс",
    bank_card: "Банковская карта",
    quick_selection: "Быстрый выбор",
    err_amount: "Пожалуйста, введите корректную сумму депозита",
    range_hint: "Допустимый диапазон для {vip}: {min} - {max}",
    err_below: "Сумма депозита не может быть меньше {min}",
    err_above: "Сумма депозита не может превышать {max}",
    err_loading_card: "Пожалуйста, подождите, загружаем вашу банковскую карту",
    err_add_card:
      "Сначала добавьте банковскую карту в разделе Мой профиль → Счёт для вывода",
    info_title: "Данные банковской карты",
    info_hint:
      "Данные банковской карты автоматически берутся из вашего счёта для вывода (Мой профиль).",
    bank_name: "Название банка",
    card_number: "Номер карты",
    account_holder: "Имя владельца счёта",
    ph_bank_name: "Введите название банка",
    ph_card_number: "Введите номер карты",
    ph_account_holder: "Введите имя на банковском счёте",
    waiting_title: "Ожидание подтверждения....",
    waiting_text:
      "Ваша заявка на пополнение отправлена. Пожалуйста, дождитесь подтверждения администратора.",
  },

  withdraw: {
    title: "Вывод",
    amount_label: "Сумма вывода",
    total_balance: "Общий баланс",
    method_title: "Способ вывода",
    method_hint:
      "Эти данные берутся из вашего счёта для вывода (Мой профиль) и не могут быть изменены здесь.",
    bank_card: "Банковская карта",
    usdt: "USDT",
    wise: "Wise",
    revolut: "Revolut",
    bank_name: "Название банка",
    bank_account: "Банковский счёт/USDT",
    full_name: "Полное имя",
    usdt_address: "Адрес USDT",
    usdt_protocol: "Протокол USDT",
    wise_email: "E-mail аккаунта Wise",
    wallet_address: "Адрес кошелька",
    security_pin: "PIN-код безопасности",
    time_title: "Время вывода",
    time_text:
      "Вывод средств разрешён только с 01:00:00 до 17:00:00. Пожалуйста, повторите попытку в это время.",
    success: "Заявка на вывод отправлена, ожидаем подтверждения",
    err_amount: "Пожалуйста, введите корректную сумму вывода",
    err_pin: "Пожалуйста, введите ваш PIN-код",
    err_loading: "Пожалуйста, подождите, загружаем ваш счёт для вывода",
    err_details:
      "Сначала добавьте данные ({method}) в разделе Мой профиль → Счёт для вывода",
    err_bank: "Заполните название банка, номер счёта и полное имя",
    err_usdt: "Заполните адрес USDT и полное имя",
    err_wise: "Заполните e-mail аккаунта Wise и полное имя",
    err_revolut: "Заполните адрес кошелька и полное имя",
    limit_title: "Ошибка запроса",
    err_below: "Сумма вывода не может быть меньше {min}",
    err_above: "Сумма вывода не может превышать {max}",
    err_daily: "Дневной лимит вывода достигнут. Разрешено {count} вывод(ов) в день.",
  },

  waccount: {
    title: "Счёт для вывода",
    hint:
      "Эти данные автоматически используются для депозита и вывода. После отправки они сохраняются в списке банковских карт администратора.",
    usdt_number: "Номер USDT",
    confirm_text: "Вы уверены, что хотите сохранить данные счёта для вывода?",
    saved_success: "Счёт для вывода успешно сохранён",
  },

  history: {
    pending: "Ожидает",
    completed: "Завершено",
    no_records: "Записи не найдены",
    total_amount: "Общая сумма:",
    profit: "Прибыль:",
    volume: "Объём сделок:",
    order_submitted: "Заказ успешно отправлен",
  },

  start: {
    current: "Текущий",
    profit: "Прибыль:",
    application: "Заявок:",
    welcome: "Привет! Добро пожаловать",
    commission_details: "Детали комиссии",
    today_profit: "Прибыль за сегодня",
    account_balance: "Баланс аккаунта",
    starting: "Старт",
    important_notice: "Важное уведомление",
    working_hours: "• Часы работы: 09:00:00 - 23:58:59",
    contact_line:
      "• Если есть вопросы, обратитесь в онлайн-службу поддержки!",
    processing: "Обработка...",
    start: "Старт",
    order_product: "Товар заказа",
    rating: "Рейтинг:",
    price: "Цена:",
    commission: "Комиссия:",
    order_done: "Заказ выполнен! Прибыль {amount} добавлена на ваш баланс.",
    unable_server: "Не удалось связаться с сервером",
  },

  sv: {
    online: "Онлайн",
    customer: "Поддержка",
    services: "Клиенты",
  },

  mp: {
    invitation_code: "Код приглашения",
    credit_reputation: "Кредитная репутация",
    today_profit: "Прибыль за сегодня",
    account_balance: "Баланс аккаунта",
    orders_count: "Количество заказов",
    invite_friends: "Пригласить друзей",
    invite_subtitle: "Приглашайте друзей и получайте награды",
    logout: "Выйти",
    logout_confirm: "Вы уверены, что хотите выйти?",
    footer: "Copyright © 2023 Nativz. Все права защищены.",
    user: "Пользователь",
  },

  lp: {
    old_password: "Старый пароль",
    new_password: "Новый пароль",
    confirm_password: "Подтвердите новый пароль",
    note: "Если вы забыли старый пароль для входа, обратитесь в службу поддержки.",
    err_min: "Новый пароль должен содержать не менее 6 символов",
    err_mismatch: "Новый пароль и подтверждение пароля не совпадают",
  },

  sp: {
    old_pin: "Старый PIN",
    new_pin: "Новый PIN",
    confirm_pin: "Подтвердите новый PIN",
    note: "Если вы забыли старый PIN-код, обратитесь в службу поддержки.",
    err_min: "Новый PIN должен содержать не менее 6 символов",
    err_mismatch: "Новый PIN и подтверждение PIN не совпадают",
  },

  dh: {
    title: "История депозитов",
    empty: "Истории депозитов пока нет",
  },

  wh: {
    title: "История выводов",
    empty: "Истории выводов пока нет",
  },

  ifr: {
    title: "Пригласить друзей",
    link_copied: "Ссылка скопирована",
    copy_prompt: "Скопируйте эту ссылку:",
  },

  faq: {
    title: "FAQ",
    important_reminder: "Важное напоминание",
    reminder_text:
      "Любая злонамеренная деятельность по отмыванию денег строго запрещена. При обнаружении платформа заморозит указанные ниже аккаунты и примет соответствующие правовые меры.",
    deposit_heading: "Депозит",
    deposit_text:
      "Каждый депозит необходимо отправить в службу поддержки для пополнения вашего аккаунта. После перевода средств на счёт, предоставленный командой поддержки платформы, предоставьте подтверждение успешного перевода. Чтобы обеспечить мгновенное зачисление депозита, убедитесь, что имя получателя и сумма перевода совпадают. Если в процессе депозита возникнут нерешённые вопросы, обратитесь в службу поддержки. Из-за большого объёма информации внимательно проверьте детали перед завершением операции. Платформа может периодически изменять данные вашего аккаунта. Если в процессе депозита возникнут нерешённые вопросы, обратитесь в службу поддержки. Если у вас есть вопросы, обратитесь в онлайн-службу поддержки платформы.",
    withdraw_heading: "Вывод средств",
    withdraw_text:
      'Перед выводом средств привяжите адрес для вывода к платформе. Чтобы вывести средства, перейдите на экран "Вывод средств" на главной странице, нажмите кнопку "Вывод" и введите сумму, которую хотите вывести, и пароль для вывода.',
    note: "(Примечание: обратитесь в нашу службу поддержки за помощью.)",
  },

  ir: {
    title: "Правила приглашений",
    p1: "Участники платформы могут использовать реферальные коды, чтобы приглашать других в вашу команду. Вы получите процентную комиссию с заработка участников вашей команды. Заработок будет возвращён вам напрямую через ваш аккаунт на платформе или в отчётах вашей команды.",
    notice: "Уведомление:",
    p2: "Все агенты и их подчинённые участники получают определённый процент дохода и бонусов от платформы. Доход составляет 30% от комиссий, заработанных их подчинёнными участниками. Платформа не оказывает поддержки в развитии подчинённых участников команды и не влияет негативно на доход и бонусы агентов.",
  },

  vr: {
    title: "Правила VIP",
    p1: "VIP 1 включает 30 заказов за цикл. Для выполнения этих заказов требуется минимальный баланс 25 USDT. Лимит вывода для этого уровня составляет от 100 USDT до максимум 5 000 USDT.",
    p2: "VIP 2 включает 40 заказов за цикл. Для перехода на VIP 2 требуется минимальный депозит 1 500 USDT. Лимит вывода для этого уровня составляет от 100 USDT до максимум 10 000 USDT.",
    p3: "VIP 3 включает 50 заказов за цикл. Для открытия VIP 3 требуется минимальный депозит 5 000 USDT. Лимит вывода для этого уровня составляет от 100 USDT до максимум 50 000 USDT.",
    p4: "VIP 4 включает 60 заказов за цикл. Для открытия VIP 4 требуется минимальный депозит 10 000 USDT. Лимит вывода для этого уровня составляет от 100 USDT до максимум 1 000 000 USDT. Пользователи VIP 4 также получают дополнительную комиссию 10% по сравнению с более низкими уровнями VIP.",
  },

  ad: {
    title: "О нас",
    intro:
      "Условия регистрации в качестве партнёра, магазина, платформы или сотрудника в Oneforma.",
    h_agreement: "Ваше соглашение",
    p1: '1. Перед использованием, просмотром или созданием аккаунта на платформе oneforma.com ("OneForma") внимательно прочитайте эти условия ("Условия", "Условия и положения"). Ваш доступ к OneForma и его использование зависят от вашего принятия и соблюдения этих Условий, а также CENTIFIC GLOBAL SOLUTIONS, Inc. ("CENTIFIC"). Эти Условия распространяются на всех посетителей, пользователей, зрителей и иных лиц, получающих доступ к OneForma или использующих её.',
    p2: '2. Предоставляя любые услуги или выполняя любые проекты, выделенные на платформе Oneforma, вы подтверждаете, что вы ("вы", ваш партнёр, магазин-партнёр, платформа-партнёр и персонал) заключили с CENTIFIC Соглашение об оказании услуг, которое содержит условия и положения, применимые положения законодательства, описание услуг или рабочего заказа и иные письменные документы, согласованные обеими сторонами ("Соглашение"). В случае противоречия между настоящими Условиями и любыми ранее заключёнными вами соглашениями по этому вопросу имеют приоритет настоящие Условия.',
    p3: "3. Регистрируясь в OneForma или используя её, вы соглашаетесь соблюдать это Соглашение. Если вы не согласны с любым пунктом или со всем Соглашением целиком, вы не можете регистрироваться в OneForma.",
    h_relationships: "Отношения между всеми сторонами",
    p4: "1.1. Роль CENTIFIC. OneForma — это платформа под управлением CENTIFIC, расположенная по адресу 14980 NE 31st Way, Suite 100, Redmond, WA 98052. Контактный e-mail: omegaguttakdl53@gmail.com",
    p5: 'CENTIFIC предоставляет платформу OneForma, позволяя пользователям самостоятельно принимать решения о заключении соглашений. Вы оказываете услуги третьим лицам или CENTIFIC ("Владелец проекта"), которые поручают работу или проекты на OneForma. Любые услуги или работа, выполняемые вами по этому соглашению, предназначены для Владельца проекта и не являются частью обычной хозяйственной деятельности CENTIFIC ("Услуги").',
    h_deliverables: "1.2. Результаты",
    p6: "CENTIFIC не предоставляет вам постоянное рабочее место и не требует выполнения услуг в специально оборудованном месте. Вы самостоятельно определяете место работы для каждого проекта. Для любого проекта, требующего работы на месте, вы оставляете за собой абсолютное право отказаться от такого проекта.",
    h_statement: "1.3. Ваше заявление",
    p7: "Читая это соглашение, вы заявляете и гарантируете CENTIFIC, что:",
    p8: "Вы обычно занимаетесь самостоятельно установленной торговлей или предпринимательской деятельностью того же характера, что и услуги по настоящему Соглашению. Вы или персонал проекта должны обладать навыками, опытом и квалификацией, необходимыми для оказания услуг;",
    p9: "Вы или ваша команда проекта должны оказывать услуги профессионально и квалифицированно, соблюдая лучшие отраслевые стандарты для аналогичных услуг и требования как центрального правительства, так и владельца проекта. Вы или ваша команда проекта должны выделять достаточные ресурсы для своевременного и надёжного оказания услуг.",
    p10: "Вы или ваш персонал проекта должны оказывать услуги в соответствии со всеми применимыми федеральными, государственными и иными национальными и местными законами и нормативными актами, включая сохранение всех лицензий, разрешений и регистраций, необходимых для оказания услуг;",
    p11: "Вы имеете право заключать настоящее соглашение, нанимать персонал проекта или предоставлять права в соответствии с соответствующими условиями настоящего соглашения, и вы несёте полную ответственность за исполнение всех услуг по этому соглашению;",
    p12: "Вы предоставляете за свой счёт все материалы, оборудование, принадности и иные ресурсы, необходимые для оказания Услуг, включая любые командировочные расходы и иные затраты, понесённые вами или вашим персоналом при оказании Услуг; вы и ваш персонал не имеете права на какой-либо отпуск, групповое медицинское или личное страхование, страхование от нетрудоспособности, участие в прибылях или пенсионные льготы, а также на иные дополнительные льготы или программы благосостояния, предоставляемые CENTIFIC своим сотрудникам; CENTIFIC не несёт обязанности удерживать или уплачивать какой-либо подоходный налог, взносы, налоги на социальное страхование или иные федеральные, государственные или местные налоги, оплачивать страховые взносы (включая взносы на страхование по безработице или нетрудоспособности) или оформлять страхование от несчастных случаев на производстве от вашего имени, если иное не предусмотрено применимым законодательством; вы обязаны возмещать CENTIFIC все такие налоги или взносы, включая штрафы и проценты, и вы прямо отказываетесь от любого права требовать от CENTIFIC возмещения любого ущерба, который вы (а также ваши сотрудники и подрядчики) можете понести при оказании Услуг по настоящему Соглашению.",
    h_term: "2. Срок и расторжение",
    p13: "2.1. Настоящее Соглашение вступает в силу с даты регистрации в качестве держателя аккаунта OneForma и действует до его расторжения по взаимному согласию вас и CENTIFIC или любой из сторон в соответствии с разделом 2.2.",
    p14: "2.2. Расторжение. Независимо от какого-либо противоположного положения настоящего Соглашения, CENTIFIC может расторгнуть вашу регистрацию в OneForma в любое время, по любой причине или без неё, уведомив об этом письменно за 30 дней. В дополнение к любым средствам правовой защиты, предусмотренным настоящим Соглашением, CENTIFIC также может расторгнуть настоящее Соглашение немедленно по уведомлению вас, если вы:",
    p15: "До или в момент подписания настоящего Соглашения Компания не предоставила соответствующую информацию или документы, разумно запрошенные CENTIFIC, либо предоставила CENTIFIC ложную или вводящую в заблуждение информацию или документы.",
    p16: "Совершаете любую мошенническую деятельность, включая, но не ограничиваясь:",
    p17: "Подделкой вашей карты посещаемости; завышением цен; введением в заблуждение или совершением мошеннических заявлений в отношении CENTIFIC или владельца проекта с использованием автоматических машин для оказания услуг без предварительного согласия владельца проекта;",
    p18: "Существенным нарушением настоящего Соглашения и Соглашения о неразглашении, если такое нарушение неустранимо, либо, даже если оно устранимо, не устранено в течение 7 дней с момента направления уведомления о таком нарушении; либо нарушением любого заявления или гарантии, предоставленных вами по настоящему Соглашению или соответствующему SOW.",
    p19: "Вы можете расторгнуть настоящее Соглашение, удалив свой аккаунт из OneForma. В этом случае вы должны предоставить CENTIFIC письменное заявление с указанием общей суммы, которую CENTIFIC вам должен на дату расторжения. Затем CENTIFIC выплатит эту сумму в соответствии с условиями и процедурой, изложенными в разделе 3 настоящих Условий.",
    p20: "Вы понимаете и подтверждаете, что закрытие любого проекта или расторжение любого SOW не приводит автоматически к расторжению настоящего Соглашения. и ваш доступ к OneForma был прекращён.",
    h_consequences: "2.3. Последствия расторжения",
    p21: "Когда настоящее Соглашение истекает или расторгается по любой причине, а также в любое иное время по письменному требованию CENTIFIC или Владельца проекта, вы обязаны в течение трёх дней после такого истечения или расторжения передать CENTIFIC и / или Владельцу проекта все результаты (завершённые или незавершённые), а также все материалы, оборудование и иное имущество, предоставленные вам CENTIFIC или Владельцем проекта для использования;",
    p22: "Передать CENTIFIC или владельцу проекта все материальные документы и иные носители, включая любые копии, которые содержат, отражают, включают или основаны на конфиденциальной информации;",
    p23: "Вы должны навсегда удалить всю конфиденциальную информацию с вашего компьютера и фотосистемы; и предоставить CENTIFIC и владельцу проекта письменное подтверждение о соблюдении требований данного раздела. Если иное не предусмотрено законом, при закрытии вашего аккаунта вы больше не сможете получить доступ к какой-либо информации или материалам, хранящимся вами в OneForma, а любое содержимое вашего аккаунта может быть удалено, за что CENTIFIC прямо отказывается от какой-либо ответственности. CENTIFIC вправе сохранить часть или всю информацию вашего аккаунта, если это разрешено или предусмотрено законом и политиками конфиденциальности.",
    h_payment: "3. Оплата",
    h_payment_method: "3.1 Способ оплаты",
    p24: "По умолчанию платежи производятся через Payoneer. Заключая договор с Payoneer или предоставляя платёжную информацию Payoneer через OneForma, вы подтверждаете и соглашаетесь, что: (а) ваш аккаунт в Payoneer и связанные услуги по управлению средствами регулируются исключительно условиями Payoneer; (б) CENTIFIC не несёт перед вами ответственности за услуги по управлению средствами, предоставляемые Payoneer, и не даёт никаких заявлений или гарантий относительно таких услуг; (в) CENTIFIC не несёт прямой или косвенной ответственности за любой фактический или предполагаемый ущерб или потери, возникшие в связи с использованием или использованием услуг по управлению средствами, предоставляемых Payoneer; и (г) вы безотзывно отказываетесь от любых претензий к CENTIFIC и его аффилированным лицам в связи с такими услугами. Если вы предпочитаете другие способы оплаты, напишите на omegaguttakdl53@gmail.com",
    p25: "Вы также подтверждаете и соглашаетесь, что CENTIFIC не несёт ответственности за любые сбои платежей, вызванные применимым законодательством или любыми ограничениями, наложенными вашим финансовым учреждением, а также за любые кредитные или дебетовые записи финансового учреждения, связанные с вашим аккаунтом Payoneer или любым иным способом оплаты, согласованным вами и CENTIFIC. CENTIFIC приложит коммерчески разумные усилия для совместной работы с вами по урегулированию таких транзакций способом, соответствующим настоящему Соглашению и любому применимому законодательству.",
    h_currency: "3.2. Валюта и порядок платежей",
    p26: "В зависимости от владельца проекта и услуг, которые вы выбираете для выполнения, CENTIFIC по своему усмотрению вправе производить оплату в долларах США, юанях или любой другой валюте.",
    h_prepay: "3.3. Правила предоплаты",
    p27: "Мы сотрудничаем с отельными партнёрами, и ваша текущая работа по бронированию осуществляется на основе предоплаты. Поскольку OneForma предоставляет только платформу для совместной работы всем участникам, вам необходимо внести средства заранее, прежде чем приступать к задачам с предоплатой. После завершения каждого заказа система автоматически вернёт заработанную сумму и вашу комиссию. Поэтому вам необходимо начать работу на основе предоплаты. Регистрируясь в OneForma или используя её, вы соглашаетесь соблюдать настоящее соглашение. Если вы не согласны с любым пунктом или со всем соглашением целиком, вы не можете регистрироваться в OneForma. Внимательно прочитайте наши соответствующие политики конфиденциальности и правила.",
    h_nofees: "3.5. Отсутствие обязательств по оплате сборов",
    p28: "Вы несёте все расходы, понесённые вами, включая, но не ограничиваясь, командировочными и иными деловыми расходами, понесёнными вами или вашими сотрудниками, агентами или подрядчиками при оказании услуг по настоящему Соглашению. Ни CENTIFIC, ни Владелец проекта не несут ответственности за любые расходы, понесённые вами или вашими сотрудниками, агентами или подрядчиками при исполнении своих обязанностей по настоящему Соглашению.",
    h_tax: "3.4. Налогообложение",
    p29: "Для всех пользователей и налогоплательщиков все ваши налоги уплачиваются авансом в OneForma. Любым платежом, который вы совершаете в OneForma, вы подтверждаете и соглашаетесь, что OneForma удержала или уплатила любой подоходный налог, взносы, налоги на социальное страхование или иные налоги. OneForma не несёт ответственности за уплату страховых взносов (включая взносы на страхование по безработице или нетрудоспособности) или оформление страхования от несчастных случаев на производстве. От вашего имени, если иное не предусмотрено применимым законодательством, вы обязаны возмещать CENTIFIC все такие налоги или взносы, включая штрафы и проценты.",
    p30: "Для налогоплательщиков в любой другой юрисдикции вы несёте ответственность за любые налоги с платежей, полученных из OneForma. Если вы не уплачиваете налоги в соответствии с применимым законодательством, OneForma заморозит ваш аккаунт и без предварительного уведомления предоставит соответствующей налоговой юрисдикции доказательства уклонения от уплаты налогов, напрямую обратившись в суд вашей налоговой юрисдикции через OneForma.",
  },

  app: {
    rejected_title: "Вывод отклонён",
  },
};

export default ru;
